import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import { format } from "@/utils/util";
import { loginCountPie, loginCountLine } from "@/service/log";
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from "echarts/core";
// 引入图表，图表后缀都为 Chart
import { PieChart, LineChart } from "echarts/charts";
// 引入提示框，标题，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
require("echarts/lib/component/legend");
import { TitleComponent, TooltipComponent, GridComponent, DatasetComponent, TransformComponent } from "echarts/components";
// 标签自动布局，全局过渡动画等特性
import { LabelLayout, UniversalTransition } from "echarts/features";
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from "echarts/renderers";
// 注册必须的组件
echarts.use([TitleComponent, TooltipComponent, GridComponent, DatasetComponent, TransformComponent, PieChart, LineChart, LabelLayout, UniversalTransition, CanvasRenderer]);
export default {
  name: "WeekInAreaChars",
  data() {
    return {
      modal: {
        visible: false
      },
      total: 0,
      dataPie: [],
      colors: [],
      line: {
        legendData: [],
        xAxisData: [],
        series: [],
        colors: []
      },
      crumb: {
        list: []
      },
      time: {},
      instance: {
        pieChart: null,
        lineChart: null
      },
      loginTimeTypeName: ""
    };
  },
  methods: {
    async open(obj, loginTimeTypeName) {
      console.log("loginTimeTypeName", loginTimeTypeName);
      if (loginTimeTypeName == "Week") {
        this.loginTimeTypeName = $t("fyi98c7", "周部门登录统计");
      } else {
        this.loginTimeTypeName = $t("1tdobo7", "月部门登录统计");
      }
      this.getTimeEndNow(obj);
      this.setCrumb(obj, "init");
      await this.setPie(obj);
      this.setLine(obj);
      this.modal.visible = true;
    },
    /*
     ** 获取饼图数据并绘制
     */
    async setPie(obj, fn) {
      // 找到元素的大小,防止画个基础约定的100px大小图形
      let booPie = await this.getLoginCountPie(obj);
      if (booPie) {
        setTimeout(() => {
          // 清除实例
          this.clearChart();
          this.drawPie();
          fn && fn();
        }, 0);
      }
    },
    /*
     ** 获取折线图数据并绘制
     */
    async setLine(obj) {
      // 找到元素的大小,防止画个基础约定的100px大小图形
      await this.getLoginCountLine(obj);
      setTimeout(() => {
        // 清除实例
        this.drawLine();
      }, 0);
    },
    /*
     ** 设置面包屑数据
     */
    setCrumb(obj, type, index) {
      switch (type) {
        case "init":
          this.crumb.list.push(obj);
          break;
        case "splice":
          // 删除index后面的数据
          this.crumb.list.splice(index + 1, this.crumb.list.length - (index + 1));
          break;
        default:
          {
            // 如果已经存在，不添加
            if (this.crumb.list.some(v => v.orgId === obj.orgId)) {
              return;
            }
            // 为了让时间保持统一
            let newObj = {
              ...this.crumb.list[0],
              orgId: obj.orgId,
              depName: obj.depName
            };
            this.crumb.list.push(newObj);
            break;
          }
      }
    },
    /*
     ** 获取面包屑数据
     */
    getCrumb(name) {
      return this.crumb.list.find(v => v.depName === name);
    },
    async onChangeCrumb(item, index) {
      // 清除后面的面包屑
      this.setCrumb(null, "splice", index);
      // 获取对应的数据
      await this.setPie(this.getCrumb(item.depName));
      this.setLine(this.getCrumb(item.depName));
    },
    /*
     ** 获取当前每一天时间，组成数组
     */
    getTimeEndNow(obj) {
      let days = [];
      let nowDay = Date.now();
      // 年-月-日格式
      let startDate = obj.startDate.split(" ")[0];
      // 转换为时间戳
      startDate = new Date(startDate).getTime();
      for (let i = startDate; i <= nowDay; i = i + 24 * 60 * 60 * 1000) {
        days.push(format(i));
      }
      this.line.xAxisData = [...days];
    },
    /* 不显示弹窗 */
    clean() {
      this.crumb.list = [];
      this.modal.visible = false;
    },
    clearChart() {
      this.instance.pieChart && this.instance.pieChart.dispose();
      this.instance.lineChart && this.instance.lineChart.dispose();
    },
    async getLoginCountPie(obj) {
      let res = await loginCountPie(obj);
      if (res.data && res.data.result === 0) {
        let total = 0;
        let dataPie = res.data.retVal;
        this.setEchartColor(dataPie, this.colors);
        dataPie.forEach(v => {
          v.value = v.number;
          v.name = v.depName;
          total += Number(v.number);
        });
        if (dataPie.length > 0) {
          this.dataPie = dataPie;
          this.total = total;
        }
        return Boolean(dataPie.length);
      }
    },
    async getLoginCountLine(obj) {
      let res = await loginCountLine(obj);
      if (res.data && res.data.result === 0) {
        let lines = res.data.retVal;
        let arr = lines.map(v => {
          this.line.legendData.push(v.depName);
          return {
            name: v.depName,
            type: "line",
            data: this.line.xAxisData.map(item => {
              let objTime = v.reportData.find(f => f.dateTime.split(" ")[0] === item);
              if (objTime) {
                return objTime.number;
              } else {
                return 0;
              }
            })
          };
        });
        this.setEchartColor(arr, this.line.colors);
        this.line.series = arr;
      }
    },
    /*
     **随机生成颜色
     */
    handleColors() {
      let color = "";
      let r = Math.floor(Math.random() * 256);
      let g = Math.floor(Math.random() * 256);
      let b = Math.floor(Math.random() * 256);
      color = `rgb(${r},${g},${b})`;
      return color; //所有方法的拼接都可以用ES6新特性`其他字符串{$变量名}`替换
    },
    /*
     **根据种类数量生成颜色列表
     */
    setEchartColor(data, colors) {
      for (let i = 0; i < data.length; i++) {
        let color = "";
        // 防止颜色重复
        let change = () => {
          color = this.colorHex(this.handleColors());
          if (this.colors.some(v => v === color)) {
            change();
          }
        };
        change();
        colors.push(color);
      }
    },
    /*
     **rgb颜色转十六进制
     */
    colorHex(string) {
      let reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
      if (/^(rgb|RGB)/.test(string)) {
        let aColor = string.replace(/(?:\(|\)|rgb|RGB)*/g, "").split(",");
        let strHex = "#";
        for (let i = 0; i < aColor.length; i++) {
          let hex = Number(aColor[i]).toString(16);
          if (hex === "0") {
            hex += hex;
          }
          strHex += hex;
        }
        if (strHex.length !== 7) {
          strHex = string;
        }
        return strHex;
      } else if (reg.test(string)) {
        let aNum = string.replace(/#/, "").split("");
        if (aNum.length === 6) {
          return string;
        } else if (aNum.length === 3) {
          let numHex = "#";
          for (let i = 0; i < aNum.length; i += 1) {
            numHex += aNum[i] + aNum[i];
          }
          return numHex;
        }
      } else {
        return string;
      }
    },
    /*
     ** 部门饼图
     */
    drawPie() {
      console.log(document.getElementById("myChartPie"));

      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(this.$refs.myChartPie);
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: "item"
        },
        legend: {
          orient: "horizontal",
          top: "0",
          width: "100%"
        },
        color: this.colors,
        series: [{
          type: "pie",
          radius: "50%",
          center: [260, 250],
          label: {
            show: false
          },
          data: this.dataPie,
          // [
          //   { value: 1048, name: "Search Engine" },
          //   { value: 735, name: "Direct" },
          //   { value: 580, name: "Email" },
          //   { value: 484, name: "Union Ads" },
          //   { value: 300, name: "Video Ads" },
          // ],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }]
      });
      // 添加点击事件
      myChart.on("click", param => {
        // 同一级部门名称不会相同
        let nowClickObj = this.dataPie.find(v => v.depName === param.name);
        let crmObj = {
          ...this.crumb.list[0],
          orgId: nowClickObj.orgId,
          depName: nowClickObj.depName
        };
        // 折线图跟饼图重绘
        this.setPie(crmObj, () => {
          this.setCrumb(nowClickObj);
          this.setLine(crmObj);
        });
      });
      this.instance.pieChart = myChart;
    },
    /*
     ** 部门折线图
     */
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(this.$refs.myChartLine);
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: this.line.legendData
        },
        color: this.line.colors,
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.line.xAxisData
        },
        yAxis: {
          type: "value"
        },
        series: this.line.series
      });
      // {
      //       name: "Email",
      //       type: "line",
      //       stack: "Total",
      //       data: [120, 132, 134, 90, 230, 210],
      //     },
      //     {
      //       name: "Union Ads",
      //       type: "line",
      //       stack: "Total",
      //       data: [220, 182, 234, 290, 330, null],
      //     },
      this.instance.lineChart = myChart;
    }
  }
};